<template>
    <div>
        <nav-secondary :navOptions="navOptions"></nav-secondary>
        <router-view class="flex-page-content flex-container view"/>
    </div>
</template>

<script>
import NavSecondary from '@/components/NavSecondary'

export default {
    components: { NavSecondary, },
    data() {
        return {
            navOptions: [
                {'text': 'Plans', 'value': 'admin-accruals-plans'},
            ]
        }
    },
    mounted() {
        const routes = this.navOptions.map(x => x.value)
        if (this.$route.name == 'admin-accruals') {
            this.$router.replace({name: routes[0]})
        }
    },
}
</script>
